import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentoSalida } from '../../model/documento-salida';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';
import { Socio } from '../../model/socio';
import { SocioService } from '../../services/socio.service';

import { BodegaService } from '../../services/bodega.service';
import { Bodega } from '../../model/bodega';

@Component({
  selector: 'app-documento-salida-cabecera',
  templateUrl: './documento-salida-cabecera.component.html',
  styleUrls: ['./documento-salida-cabecera.component.css']
})
export class DocumentoSalidaCabeceraComponent implements OnInit {


  @Input() cabecera: DocumentoSalida;
  @Input() consorcio: Consorcio;
  @Input() sucursal: Sucursal;
  @Output() onReturn = new EventEmitter();
  @Output() onGuardar = new EventEmitter();


  public socios: Socio[];

  public bodegas: Bodega[];
  public bodega: Bodega;
  public socio: Socio;


  public query: any;


  constructor(private _socioService: SocioService, private _bodegaService: BodegaService) { }

  ngOnInit() {

    if (this.cabecera === undefined) {
      this.cabecera = new DocumentoSalida();
    }

    this.cargarSocios();
    this.cargarBodegas();

  }

  cargarSocios() {

    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      tipo: "CLIENTE"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
      data => this.socios = data,
      err => {
        console.clear();
        console.log(err._body);
      });

  }

  cargarBodegas() {
    this._bodegaService.getBodegas()
      .subscribe(
      data => this.bodegas = data,
      err => {
        console.log(err);
      });
  }

  regresarListad() {
    this.onReturn.emit();
  }

  guardar() {
    this.onGuardar.emit();
  }

  seleccionBodega(bodega: Bodega) {
      this.cabecera.codigoBodega = bodega.codigoBodega;
  }

  seleccionCliente(){
    this.cabecera.codigoCliente = this.socio.codigoSocio;
  }
}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-salida-cabecera/documento-salida-cabecera.component.ts